import * as React from "react";
import { isMarketType, getDictPhrase } from "../../../../../../helpers";
import { BetBtnRegular } from "../../../../components";
export var renderBetButtonsRegular = function (cardProps, market, componentPrefix) {
    return (React.createElement("div", { key: componentPrefix + "__" + market.id, className: "rj-ev-list__" + componentPrefix + "__section rj-ev-list__" + componentPrefix + "__section--" + market.template, "data-uat": "div-ev-list-" + componentPrefix + "-section" }, market.selections && market.selections.map(function (s, index) {
        var betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
        var name = getSelectionName(cardProps, market, s);
        return (React.createElement(BetBtnRegular, { key: componentPrefix + "__bet-btn__" + (market.id || "m") + "-" + (s && s.id || "s") + "-" + index, isDisabled: s.isDisabled, classNames: betslipModifier, handler: function () { return cardProps.handlers.betButton(market, s); }, text: name, point: s.pointsText, odd: s.odds, trueOdds: s.trueOdds, hideLowOdds: cardProps.hideLowOdds }));
    })));
};
export var getSelectionName = function (cardProps, market, selection) {
    if (isMarketType(market.marketType.id, "HC") && !cardProps.isDesktop) {
        return "";
    }
    if (isMarketType(market.marketType.id, "ML")
        && !cardProps.showMLTeamName
        && selection.outcomeType !== null) {
        return getDictPhrase(cardProps.dict, selection.outcomeType);
    }
    return selection.name;
};
//# sourceMappingURL=renderBetButtonsRegular.js.map